/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AIFISettings,
  AvailableFiltersResp,
  AvailableTagsResp,
  ChartAddReq,
  ChartAddResp,
  ChartUpdateReq,
  ChartUpdateResp,
  ConvertToDefaultReportResp,
  CreateAPIKeyReq,
  CreateAPIKeyResp,
  CreateProjectReq,
  CreateProjectResp,
  CreateReportReq,
  CreateReportResp,
  CreateTemplateReq,
  CreateVariableReq,
  CreateVariableResp,
  DeleteFilterGroupParams,
  DeleteProjectAggregateParams,
  DeleteVariableBody,
  DeleteVariableImpactResp,
  DeleteVariableResp,
  EditProjectUsersReq,
  FavoriteReportResp,
  FilterGroup,
  FilterGroupUpsert,
  GetAvailableAggregatesResp,
  GetAvailableFiltersParams,
  GetChartResp,
  GetCustomTemplatesParams,
  GetDefaultTemplatesParams,
  GetFavoriteReportsParams,
  GetProjectConfigurationReq,
  GetProjectConfigurationResp,
  GetProjectDetailedReportsResp,
  GetProjectReportsParams,
  GetProjectsResp,
  GetReportParams,
  GetReportResp,
  GetReportsResp,
  GetReportsSidebarLayoutResp,
  GetTagTemplatesParams,
  GetUsersPageResp,
  GetUsersPaginatedParams,
  GetUsersPayload,
  HTTPValidationError,
  Language,
  LegacySearchResults,
  ListAPIKeysResp,
  ListProjectROIHourlyCostTagValuesParams,
  ListProjectROITaxonomyGroupsParams,
  ListROIHourlyCostTagValuesResp,
  ListROITaxonomyGroupsResp,
  MoveChartReq,
  PaginatedReportTemplate,
  ProcessingStatusResp,
  ProjectAggregate,
  ProjectConfiguration,
  ProjectUsersResp,
  ReorderChartsReq,
  ReportTemplate,
  ResponseMessage,
  SearchProjectsReq,
  SetReportsSidebarLayoutReq,
  SetReportsSidebarLayoutResp,
  SummaryLanguageOptionsResp,
  TranslationOptionsResp,
  UpdateConfigurationParams,
  UpdateProjectAIFISettingsReq,
  UpdateProjectROIConfigurationReq,
  UpdateProjectROIConfigurationResp,
  UpdateProjectReq,
  UpdateProjectSummaryLanguageReq,
  UpdateProjectTranslation200,
  UpdateProjectTranslationReq,
  UpdateReportReq,
  UpdateReportResp,
  UpdateVariableResp,
  UpsertProjectAggregateParams,
} from '../model';

import { customFetch } from '../../fetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCreateChartUrl = (reportId: string) => {
  return `/api/v1/projects/reports/${reportId}/charts`;
};

/**
 * @summary Chart Add
 */
export const createChart = async (
  reportId: string,
  chartAddReq: ChartAddReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<ChartAddResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ChartAddResp>(getCreateChartUrl(reportId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(chartAddReq),
  });
};

export const getCreateChartMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createChart>>,
    TError,
    CreateChartMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof createChart>>, TError, CreateChartMutationVariables, TContext> => {
  const mutationKey = ['createChart'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof createChart>>, CreateChartMutationVariables> = (
    props,
  ) => {
    const { reportId, data } = props ?? {};

    return createChart(reportId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateChartMutationResult = NonNullable<Awaited<ReturnType<typeof createChart>>>;
export type CreateChartMutationBody = ChartAddReq;
export type CreateChartMutationError = HTTPValidationError;
export type CreateChartMutationVariables = { reportId: string; data: ChartAddReq };

/**
 * @summary Chart Add
 */
export const useCreateChart = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createChart>>,
    TError,
    CreateChartMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof createChart>>, TError, CreateChartMutationVariables, TContext> => {
  return useMutation(getCreateChartMutationOptions(options));
};
export const getUpdateChartUrl = (chartId: string) => {
  return `/api/v1/projects/reports/charts/${chartId}`;
};

/**
 * @summary Chart Update
 */
export const updateChart = async (
  chartId: string,
  chartUpdateReq: ChartUpdateReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<ChartUpdateResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ChartUpdateResp>(getUpdateChartUrl(chartId), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(chartUpdateReq),
  });
};

export const getUpdateChartMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateChart>>,
    TError,
    UpdateChartMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof updateChart>>, TError, UpdateChartMutationVariables, TContext> => {
  const mutationKey = ['updateChart'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateChart>>, UpdateChartMutationVariables> = (
    props,
  ) => {
    const { chartId, data } = props ?? {};

    return updateChart(chartId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateChartMutationResult = NonNullable<Awaited<ReturnType<typeof updateChart>>>;
export type UpdateChartMutationBody = ChartUpdateReq;
export type UpdateChartMutationError = HTTPValidationError;
export type UpdateChartMutationVariables = { chartId: string; data: ChartUpdateReq };

/**
 * @summary Chart Update
 */
export const useUpdateChart = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateChart>>,
    TError,
    UpdateChartMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof updateChart>>, TError, UpdateChartMutationVariables, TContext> => {
  return useMutation(getUpdateChartMutationOptions(options));
};
export const getDeleteChartUrl = (chartId: string) => {
  return `/api/v1/projects/reports/charts/${chartId}`;
};

/**
 * @summary Chart Delete
 */
export const deleteChart = async (chartId: string, options?: Parameters<typeof customFetch>[1]): Promise<unknown> => {
  return customFetch<unknown>(getDeleteChartUrl(chartId), {
    ...options,
    method: 'DELETE',
  });
};

export const getDeleteChartMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteChart>>,
    TError,
    DeleteChartMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteChart>>, TError, DeleteChartMutationVariables, TContext> => {
  const mutationKey = ['deleteChart'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteChart>>, DeleteChartMutationVariables> = (
    props,
  ) => {
    const { chartId } = props ?? {};

    return deleteChart(chartId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteChartMutationResult = NonNullable<Awaited<ReturnType<typeof deleteChart>>>;

export type DeleteChartMutationError = HTTPValidationError;
export type DeleteChartMutationVariables = { chartId: string };

/**
 * @summary Chart Delete
 */
export const useDeleteChart = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteChart>>,
    TError,
    DeleteChartMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof deleteChart>>, TError, DeleteChartMutationVariables, TContext> => {
  return useMutation(getDeleteChartMutationOptions(options));
};
export const getGetChartUrl = (chartId: string) => {
  return `/api/v1/projects/reports/charts/${chartId}`;
};

/**
 * @summary Chart Get
 */
export const getChart = async (chartId: string, options?: Parameters<typeof customFetch>[1]): Promise<GetChartResp> => {
  return customFetch<GetChartResp>(getGetChartUrl(chartId), {
    ...options,
    method: 'GET',
  });
};

export const getGetChartQueryKey = (chartId: string) => {
  return [`/api/v1/projects/reports/charts/${chartId}`] as const;
};

export const getGetChartQueryOptions = <TData = Awaited<ReturnType<typeof getChart>>, TError = HTTPValidationError>(
  chartId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getChart>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChartQueryKey(chartId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChart>>> = ({ signal }) =>
    getChart(chartId, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: chartId !== null && chartId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getChart>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetChartQueryResult = NonNullable<Awaited<ReturnType<typeof getChart>>>;
export type GetChartQueryError = HTTPValidationError;

/**
 * @summary Chart Get
 */

export function useGetChart<TData = Awaited<ReturnType<typeof getChart>>, TError = HTTPValidationError>(
  chartId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getChart>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetChartQueryOptions(chartId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getMoveChartUrl = () => {
  return `/api/v1/projects/reports/charts/move`;
};

/**
 * @summary Chart Move
 */
export const moveChart = async (
  moveChartReq: MoveChartReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetChartResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GetChartResp>(getMoveChartUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(moveChartReq),
  });
};

export const getMoveChartMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof moveChart>>, TError, MoveChartMutationVariables, TContext>;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof moveChart>>, TError, MoveChartMutationVariables, TContext> => {
  const mutationKey = ['moveChart'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveChart>>, MoveChartMutationVariables> = (props) => {
    const { data } = props ?? {};

    return moveChart(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MoveChartMutationResult = NonNullable<Awaited<ReturnType<typeof moveChart>>>;
export type MoveChartMutationBody = MoveChartReq;
export type MoveChartMutationError = HTTPValidationError;
export type MoveChartMutationVariables = { data: MoveChartReq };

/**
 * @summary Chart Move
 */
export const useMoveChart = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof moveChart>>, TError, MoveChartMutationVariables, TContext>;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof moveChart>>, TError, MoveChartMutationVariables, TContext> => {
  return useMutation(getMoveChartMutationOptions(options));
};
export const getCreateProjectUrl = () => {
  return `/api/v1/projects`;
};

/**
 * Error if the project name already exists
 * @summary Create Project
 */
export const createProject = async (
  createProjectReq: CreateProjectReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<CreateProjectResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CreateProjectResp>(getCreateProjectUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createProjectReq),
  });
};

export const getCreateProjectMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProject>>,
    TError,
    CreateProjectMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError, CreateProjectMutationVariables, TContext> => {
  const mutationKey = ['createProject'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProject>>, CreateProjectMutationVariables> = (
    props,
  ) => {
    const { data } = props ?? {};

    return createProject(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof createProject>>>;
export type CreateProjectMutationBody = CreateProjectReq;
export type CreateProjectMutationError = HTTPValidationError;
export type CreateProjectMutationVariables = { data: CreateProjectReq };

/**
 * @summary Create Project
 */
export const useCreateProject = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProject>>,
    TError,
    CreateProjectMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof createProject>>, TError, CreateProjectMutationVariables, TContext> => {
  return useMutation(getCreateProjectMutationOptions(options));
};
export const getGetProjectsUrl = () => {
  return `/api/v1/projects`;
};

/**
 * @summary Get Projects
 */
export const getProjects = async (options?: Parameters<typeof customFetch>[1]): Promise<GetProjectsResp> => {
  return customFetch<GetProjectsResp>(getGetProjectsUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getGetProjectsQueryKey = () => {
  return [`/api/v1/projects`] as const;
};

export const getGetProjectsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjects>>,
  TError = HTTPValidationError,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjects>>> = ({ signal }) =>
    getProjects({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjects>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof getProjects>>>;
export type GetProjectsQueryError = HTTPValidationError;

/**
 * @summary Get Projects
 */

export function useGetProjects<
  TData = Awaited<ReturnType<typeof getProjects>>,
  TError = HTTPValidationError,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProjectsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateProjectUrl = (projectId: string) => {
  return `/api/v1/projects/${projectId}`;
};

/**
 * Error if the project name already exists
 * @summary Update Project
 */
export const updateProject = async (
  projectId: string,
  updateProjectReq: UpdateProjectReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<CreateProjectResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CreateProjectResp>(getUpdateProjectUrl(projectId), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateProjectReq),
  });
};

export const getUpdateProjectMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProject>>,
    TError,
    UpdateProjectMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError, UpdateProjectMutationVariables, TContext> => {
  const mutationKey = ['updateProject'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProject>>, UpdateProjectMutationVariables> = (
    props,
  ) => {
    const { projectId, data } = props ?? {};

    return updateProject(projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof updateProject>>>;
export type UpdateProjectMutationBody = UpdateProjectReq;
export type UpdateProjectMutationError = HTTPValidationError;
export type UpdateProjectMutationVariables = { projectId: string; data: UpdateProjectReq };

/**
 * @summary Update Project
 */
export const useUpdateProject = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProject>>,
    TError,
    UpdateProjectMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof updateProject>>, TError, UpdateProjectMutationVariables, TContext> => {
  return useMutation(getUpdateProjectMutationOptions(options));
};
export const getDeleteProjectUrl = (projectId: string) => {
  return `/api/v1/projects/${projectId}`;
};

/**
 * Error if the project name already exists
 * @summary Delete Project
 */
export const deleteProject = async (
  projectId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<unknown> => {
  return customFetch<unknown>(getDeleteProjectUrl(projectId), {
    ...options,
    method: 'DELETE',
  });
};

export const getDeleteProjectMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProject>>,
    TError,
    DeleteProjectMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError, DeleteProjectMutationVariables, TContext> => {
  const mutationKey = ['deleteProject'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProject>>, DeleteProjectMutationVariables> = (
    props,
  ) => {
    const { projectId } = props ?? {};

    return deleteProject(projectId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProjectMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProject>>>;

export type DeleteProjectMutationError = HTTPValidationError;
export type DeleteProjectMutationVariables = { projectId: string };

/**
 * @summary Delete Project
 */
export const useDeleteProject = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProject>>,
    TError,
    DeleteProjectMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof deleteProject>>, TError, DeleteProjectMutationVariables, TContext> => {
  return useMutation(getDeleteProjectMutationOptions(options));
};
export const getUpdateProjectSummaryLanguageUrl = (projectId: string) => {
  return `/api/v1/projects/${projectId}/summary-language`;
};

/**
 * @summary Update Project Summary Language
 */
export const updateProjectSummaryLanguage = async (
  projectId: string,
  updateProjectSummaryLanguageReq: UpdateProjectSummaryLanguageReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<Language> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<Language>(getUpdateProjectSummaryLanguageUrl(projectId), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateProjectSummaryLanguageReq),
  });
};

export const getUpdateProjectSummaryLanguageMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProjectSummaryLanguage>>,
    TError,
    UpdateProjectSummaryLanguageMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProjectSummaryLanguage>>,
  TError,
  UpdateProjectSummaryLanguageMutationVariables,
  TContext
> => {
  const mutationKey = ['updateProjectSummaryLanguage'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProjectSummaryLanguage>>,
    UpdateProjectSummaryLanguageMutationVariables
  > = (props) => {
    const { projectId, data } = props ?? {};

    return updateProjectSummaryLanguage(projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProjectSummaryLanguageMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProjectSummaryLanguage>>
>;
export type UpdateProjectSummaryLanguageMutationBody = UpdateProjectSummaryLanguageReq;
export type UpdateProjectSummaryLanguageMutationError = HTTPValidationError;
export type UpdateProjectSummaryLanguageMutationVariables = {
  projectId: string;
  data: UpdateProjectSummaryLanguageReq;
};

/**
 * @summary Update Project Summary Language
 */
export const useUpdateProjectSummaryLanguage = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProjectSummaryLanguage>>,
    TError,
    UpdateProjectSummaryLanguageMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateProjectSummaryLanguage>>,
  TError,
  UpdateProjectSummaryLanguageMutationVariables,
  TContext
> => {
  return useMutation(getUpdateProjectSummaryLanguageMutationOptions(options));
};
export const getUpdateProjectTranslationUrl = (projectId: string) => {
  return `/api/v1/projects/${projectId}/translation`;
};

/**
 * @summary Update Project Translation
 */
export const updateProjectTranslation = async (
  projectId: string,
  updateProjectTranslationReq: UpdateProjectTranslationReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<UpdateProjectTranslation200> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<UpdateProjectTranslation200>(getUpdateProjectTranslationUrl(projectId), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateProjectTranslationReq),
  });
};

export const getUpdateProjectTranslationMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProjectTranslation>>,
    TError,
    UpdateProjectTranslationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProjectTranslation>>,
  TError,
  UpdateProjectTranslationMutationVariables,
  TContext
> => {
  const mutationKey = ['updateProjectTranslation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProjectTranslation>>,
    UpdateProjectTranslationMutationVariables
  > = (props) => {
    const { projectId, data } = props ?? {};

    return updateProjectTranslation(projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProjectTranslationMutationResult = NonNullable<Awaited<ReturnType<typeof updateProjectTranslation>>>;
export type UpdateProjectTranslationMutationBody = UpdateProjectTranslationReq;
export type UpdateProjectTranslationMutationError = HTTPValidationError;
export type UpdateProjectTranslationMutationVariables = { projectId: string; data: UpdateProjectTranslationReq };

/**
 * @summary Update Project Translation
 */
export const useUpdateProjectTranslation = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProjectTranslation>>,
    TError,
    UpdateProjectTranslationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateProjectTranslation>>,
  TError,
  UpdateProjectTranslationMutationVariables,
  TContext
> => {
  return useMutation(getUpdateProjectTranslationMutationOptions(options));
};
export const getUpdateProjectROIConfigurationUrl = (projectId: string) => {
  return `/api/v1/projects/${projectId}/roi-configuration`;
};

/**
 * @summary Update Project Roi Configuration
 */
export const updateProjectROIConfiguration = async (
  projectId: string,
  updateProjectROIConfigurationReq: UpdateProjectROIConfigurationReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<UpdateProjectROIConfigurationResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<UpdateProjectROIConfigurationResp>(getUpdateProjectROIConfigurationUrl(projectId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateProjectROIConfigurationReq),
  });
};

export const getUpdateProjectROIConfigurationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProjectROIConfiguration>>,
    TError,
    UpdateProjectROIConfigurationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProjectROIConfiguration>>,
  TError,
  UpdateProjectROIConfigurationMutationVariables,
  TContext
> => {
  const mutationKey = ['updateProjectROIConfiguration'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProjectROIConfiguration>>,
    UpdateProjectROIConfigurationMutationVariables
  > = (props) => {
    const { projectId, data } = props ?? {};

    return updateProjectROIConfiguration(projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProjectROIConfigurationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProjectROIConfiguration>>
>;
export type UpdateProjectROIConfigurationMutationBody = UpdateProjectROIConfigurationReq;
export type UpdateProjectROIConfigurationMutationError = HTTPValidationError;
export type UpdateProjectROIConfigurationMutationVariables = {
  projectId: string;
  data: UpdateProjectROIConfigurationReq;
};

/**
 * @summary Update Project Roi Configuration
 */
export const useUpdateProjectROIConfiguration = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProjectROIConfiguration>>,
    TError,
    UpdateProjectROIConfigurationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateProjectROIConfiguration>>,
  TError,
  UpdateProjectROIConfigurationMutationVariables,
  TContext
> => {
  return useMutation(getUpdateProjectROIConfigurationMutationOptions(options));
};
export const getListProjectROITaxonomyGroupsUrl = (projectId: string, params?: ListProjectROITaxonomyGroupsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/projects/${projectId}/roi-taxonomy-groups?${stringifiedParams}`
    : `/api/v1/projects/${projectId}/roi-taxonomy-groups`;
};

/**
 * @summary List Project Roi Taxonomy Groups
 */
export const listProjectROITaxonomyGroups = async (
  projectId: string,
  params?: ListProjectROITaxonomyGroupsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<ListROITaxonomyGroupsResp> => {
  return customFetch<ListROITaxonomyGroupsResp>(getListProjectROITaxonomyGroupsUrl(projectId, params), {
    ...options,
    method: 'GET',
  });
};

export const getListProjectROITaxonomyGroupsQueryKey = (
  projectId: string,
  params?: ListProjectROITaxonomyGroupsParams,
) => {
  return [`/api/v1/projects/${projectId}/roi-taxonomy-groups`, ...(params ? [params] : [])] as const;
};

export const getListProjectROITaxonomyGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof listProjectROITaxonomyGroups>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  params?: ListProjectROITaxonomyGroupsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listProjectROITaxonomyGroups>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListProjectROITaxonomyGroupsQueryKey(projectId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectROITaxonomyGroups>>> = ({ signal }) =>
    listProjectROITaxonomyGroups(projectId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listProjectROITaxonomyGroups>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ListProjectROITaxonomyGroupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listProjectROITaxonomyGroups>>
>;
export type ListProjectROITaxonomyGroupsQueryError = HTTPValidationError;

/**
 * @summary List Project Roi Taxonomy Groups
 */

export function useListProjectROITaxonomyGroups<
  TData = Awaited<ReturnType<typeof listProjectROITaxonomyGroups>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  params?: ListProjectROITaxonomyGroupsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listProjectROITaxonomyGroups>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListProjectROITaxonomyGroupsQueryOptions(projectId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getListProjectROIHourlyCostTagValuesUrl = (
  projectId: string,
  params: ListProjectROIHourlyCostTagValuesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/projects/${projectId}/roi-hourly-cost-tag-values?${stringifiedParams}`
    : `/api/v1/projects/${projectId}/roi-hourly-cost-tag-values`;
};

/**
 * @summary List Project Roi Hourly Cost Tag Values
 */
export const listProjectROIHourlyCostTagValues = async (
  projectId: string,
  params: ListProjectROIHourlyCostTagValuesParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<ListROIHourlyCostTagValuesResp> => {
  return customFetch<ListROIHourlyCostTagValuesResp>(getListProjectROIHourlyCostTagValuesUrl(projectId, params), {
    ...options,
    method: 'GET',
  });
};

export const getListProjectROIHourlyCostTagValuesQueryKey = (
  projectId: string,
  params?: ListProjectROIHourlyCostTagValuesParams,
) => {
  return [`/api/v1/projects/${projectId}/roi-hourly-cost-tag-values`, ...(params ? [params] : [])] as const;
};

export const getListProjectROIHourlyCostTagValuesQueryOptions = <
  TData = Awaited<ReturnType<typeof listProjectROIHourlyCostTagValues>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  params: ListProjectROIHourlyCostTagValuesParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listProjectROIHourlyCostTagValues>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListProjectROIHourlyCostTagValuesQueryKey(projectId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectROIHourlyCostTagValues>>> = ({ signal }) =>
    listProjectROIHourlyCostTagValues(projectId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listProjectROIHourlyCostTagValues>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ListProjectROIHourlyCostTagValuesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listProjectROIHourlyCostTagValues>>
>;
export type ListProjectROIHourlyCostTagValuesQueryError = HTTPValidationError;

/**
 * @summary List Project Roi Hourly Cost Tag Values
 */

export function useListProjectROIHourlyCostTagValues<
  TData = Awaited<ReturnType<typeof listProjectROIHourlyCostTagValues>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  params: ListProjectROIHourlyCostTagValuesParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listProjectROIHourlyCostTagValues>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListProjectROIHourlyCostTagValuesQueryOptions(projectId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateProjectAIFISettingsUrl = (projectId: string) => {
  return `/api/v1/projects/${projectId}/aifi-settings`;
};

/**
 * @summary Update Project Aifi Settings
 */
export const updateProjectAIFISettings = async (
  projectId: string,
  updateProjectAIFISettingsReq: UpdateProjectAIFISettingsReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<AIFISettings> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AIFISettings>(getUpdateProjectAIFISettingsUrl(projectId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateProjectAIFISettingsReq),
  });
};

export const getUpdateProjectAIFISettingsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProjectAIFISettings>>,
    TError,
    UpdateProjectAIFISettingsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProjectAIFISettings>>,
  TError,
  UpdateProjectAIFISettingsMutationVariables,
  TContext
> => {
  const mutationKey = ['updateProjectAIFISettings'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProjectAIFISettings>>,
    UpdateProjectAIFISettingsMutationVariables
  > = (props) => {
    const { projectId, data } = props ?? {};

    return updateProjectAIFISettings(projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProjectAIFISettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProjectAIFISettings>>
>;
export type UpdateProjectAIFISettingsMutationBody = UpdateProjectAIFISettingsReq;
export type UpdateProjectAIFISettingsMutationError = HTTPValidationError;
export type UpdateProjectAIFISettingsMutationVariables = { projectId: string; data: UpdateProjectAIFISettingsReq };

/**
 * @summary Update Project Aifi Settings
 */
export const useUpdateProjectAIFISettings = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProjectAIFISettings>>,
    TError,
    UpdateProjectAIFISettingsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateProjectAIFISettings>>,
  TError,
  UpdateProjectAIFISettingsMutationVariables,
  TContext
> => {
  return useMutation(getUpdateProjectAIFISettingsMutationOptions(options));
};
export const getGetProjectSummaryLanguageUrl = (projectId: string) => {
  return `/api/v1/projects/${projectId}/summary-language-options`;
};

/**
 * @summary Get Project Summary Language Options
 */
export const getProjectSummaryLanguage = async (
  projectId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<SummaryLanguageOptionsResp> => {
  return customFetch<SummaryLanguageOptionsResp>(getGetProjectSummaryLanguageUrl(projectId), {
    ...options,
    method: 'GET',
  });
};

export const getGetProjectSummaryLanguageQueryKey = (projectId: string) => {
  return [`/api/v1/projects/${projectId}/summary-language-options`] as const;
};

export const getGetProjectSummaryLanguageQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectSummaryLanguage>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getProjectSummaryLanguage>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectSummaryLanguageQueryKey(projectId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectSummaryLanguage>>> = ({ signal }) =>
    getProjectSummaryLanguage(projectId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getProjectSummaryLanguage>>, TError, TData> & { queryKey: QueryKey };
};

export type GetProjectSummaryLanguageQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectSummaryLanguage>>>;
export type GetProjectSummaryLanguageQueryError = HTTPValidationError;

/**
 * @summary Get Project Summary Language Options
 */

export function useGetProjectSummaryLanguage<
  TData = Awaited<ReturnType<typeof getProjectSummaryLanguage>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getProjectSummaryLanguage>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProjectSummaryLanguageQueryOptions(projectId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetProjectTranslationOptionsUrl = (projectId: string) => {
  return `/api/v1/projects/${projectId}/translation-options`;
};

/**
 * @summary Get Project Translation Options
 */
export const getProjectTranslationOptions = async (
  projectId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<TranslationOptionsResp> => {
  return customFetch<TranslationOptionsResp>(getGetProjectTranslationOptionsUrl(projectId), {
    ...options,
    method: 'GET',
  });
};

export const getGetProjectTranslationOptionsQueryKey = (projectId: string) => {
  return [`/api/v1/projects/${projectId}/translation-options`] as const;
};

export const getGetProjectTranslationOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectTranslationOptions>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getProjectTranslationOptions>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectTranslationOptionsQueryKey(projectId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectTranslationOptions>>> = ({ signal }) =>
    getProjectTranslationOptions(projectId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getProjectTranslationOptions>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetProjectTranslationOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectTranslationOptions>>
>;
export type GetProjectTranslationOptionsQueryError = HTTPValidationError;

/**
 * @summary Get Project Translation Options
 */

export function useGetProjectTranslationOptions<
  TData = Awaited<ReturnType<typeof getProjectTranslationOptions>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getProjectTranslationOptions>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProjectTranslationOptionsQueryOptions(projectId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateReportUrl = (projectId: string) => {
  return `/api/v1/projects/${projectId}/reports`;
};

/**
 * Error if the report name already exists
 * @summary Create Report
 */
export const createReport = async (
  projectId: string,
  createReportReq: CreateReportReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<CreateReportResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CreateReportResp>(getCreateReportUrl(projectId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createReportReq),
  });
};

export const getCreateReportMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createReport>>,
    TError,
    CreateReportMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof createReport>>, TError, CreateReportMutationVariables, TContext> => {
  const mutationKey = ['createReport'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof createReport>>, CreateReportMutationVariables> = (
    props,
  ) => {
    const { projectId, data } = props ?? {};

    return createReport(projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateReportMutationResult = NonNullable<Awaited<ReturnType<typeof createReport>>>;
export type CreateReportMutationBody = CreateReportReq;
export type CreateReportMutationError = HTTPValidationError;
export type CreateReportMutationVariables = { projectId: string; data: CreateReportReq };

/**
 * @summary Create Report
 */
export const useCreateReport = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createReport>>,
    TError,
    CreateReportMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof createReport>>, TError, CreateReportMutationVariables, TContext> => {
  return useMutation(getCreateReportMutationOptions(options));
};
export const getGetProjectReportsUrl = (projectId: string, params?: GetProjectReportsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/projects/${projectId}/reports?${stringifiedParams}`
    : `/api/v1/projects/${projectId}/reports`;
};

/**
 * Error if the report name already exists
 * @deprecated
 * @summary Get Reports
 */
export const getProjectReports = async (
  projectId: string,
  params?: GetProjectReportsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetReportsResp> => {
  return customFetch<GetReportsResp>(getGetProjectReportsUrl(projectId, params), {
    ...options,
    method: 'GET',
  });
};

export const getGetProjectReportsQueryKey = (projectId: string, params?: GetProjectReportsParams) => {
  return [`/api/v1/projects/${projectId}/reports`, ...(params ? [params] : [])] as const;
};

export const getGetProjectReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectReports>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  params?: GetProjectReportsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getProjectReports>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectReportsQueryKey(projectId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectReports>>> = ({ signal }) =>
    getProjectReports(projectId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getProjectReports>>, TError, TData> & { queryKey: QueryKey };
};

export type GetProjectReportsQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectReports>>>;
export type GetProjectReportsQueryError = HTTPValidationError;

/**
 * @deprecated
 * @summary Get Reports
 */

export function useGetProjectReports<
  TData = Awaited<ReturnType<typeof getProjectReports>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  params?: GetProjectReportsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getProjectReports>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProjectReportsQueryOptions(projectId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetDefaultReportsUrl = (projectId: string) => {
  return `/api/v1/projects/${projectId}/default-reports`;
};

/**
 * Error if the report name already exists
 * @summary Get Default Reports
 */
export const getDefaultReports = async (
  projectId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetReportsResp> => {
  return customFetch<GetReportsResp>(getGetDefaultReportsUrl(projectId), {
    ...options,
    method: 'GET',
  });
};

export const getGetDefaultReportsQueryKey = (projectId: string) => {
  return [`/api/v1/projects/${projectId}/default-reports`] as const;
};

export const getGetDefaultReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDefaultReports>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getDefaultReports>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDefaultReportsQueryKey(projectId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDefaultReports>>> = ({ signal }) =>
    getDefaultReports(projectId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getDefaultReports>>, TError, TData> & { queryKey: QueryKey };
};

export type GetDefaultReportsQueryResult = NonNullable<Awaited<ReturnType<typeof getDefaultReports>>>;
export type GetDefaultReportsQueryError = HTTPValidationError;

/**
 * @summary Get Default Reports
 */

export function useGetDefaultReports<
  TData = Awaited<ReturnType<typeof getDefaultReports>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getDefaultReports>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDefaultReportsQueryOptions(projectId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetProjectDetailedReportsUrl = (projectId: string) => {
  return `/api/v1/projects/${projectId}/detailed-reports`;
};

/**
 * @summary Get Detailed Reports
 */
export const getProjectDetailedReports = async (
  projectId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetProjectDetailedReportsResp> => {
  return customFetch<GetProjectDetailedReportsResp>(getGetProjectDetailedReportsUrl(projectId), {
    ...options,
    method: 'GET',
  });
};

export const getGetProjectDetailedReportsQueryKey = (projectId: string) => {
  return [`/api/v1/projects/${projectId}/detailed-reports`] as const;
};

export const getGetProjectDetailedReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectDetailedReports>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getProjectDetailedReports>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectDetailedReportsQueryKey(projectId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectDetailedReports>>> = ({ signal }) =>
    getProjectDetailedReports(projectId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getProjectDetailedReports>>, TError, TData> & { queryKey: QueryKey };
};

export type GetProjectDetailedReportsQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectDetailedReports>>>;
export type GetProjectDetailedReportsQueryError = HTTPValidationError;

/**
 * @summary Get Detailed Reports
 */

export function useGetProjectDetailedReports<
  TData = Awaited<ReturnType<typeof getProjectDetailedReports>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getProjectDetailedReports>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProjectDetailedReportsQueryOptions(projectId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetFavoriteReportsUrl = (projectId: string, params?: GetFavoriteReportsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/projects/${projectId}/favorite-reports?${stringifiedParams}`
    : `/api/v1/projects/${projectId}/favorite-reports`;
};

/**
 * Error if the report name already exists
 * @summary Get Favorite Reports
 */
export const getFavoriteReports = async (
  projectId: string,
  params?: GetFavoriteReportsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetReportsResp> => {
  return customFetch<GetReportsResp>(getGetFavoriteReportsUrl(projectId, params), {
    ...options,
    method: 'GET',
  });
};

export const getGetFavoriteReportsQueryKey = (projectId: string, params?: GetFavoriteReportsParams) => {
  return [`/api/v1/projects/${projectId}/favorite-reports`, ...(params ? [params] : [])] as const;
};

export const getGetFavoriteReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof getFavoriteReports>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  params?: GetFavoriteReportsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getFavoriteReports>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFavoriteReportsQueryKey(projectId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFavoriteReports>>> = ({ signal }) =>
    getFavoriteReports(projectId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getFavoriteReports>>, TError, TData> & { queryKey: QueryKey };
};

export type GetFavoriteReportsQueryResult = NonNullable<Awaited<ReturnType<typeof getFavoriteReports>>>;
export type GetFavoriteReportsQueryError = HTTPValidationError;

/**
 * @summary Get Favorite Reports
 */

export function useGetFavoriteReports<
  TData = Awaited<ReturnType<typeof getFavoriteReports>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  params?: GetFavoriteReportsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getFavoriteReports>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFavoriteReportsQueryOptions(projectId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetReportsSidebarLayoutUrl = (projectId: string) => {
  return `/api/v1/projects/${projectId}/reports/sidebar-layout`;
};

/**
 * Return the mixed workspace sidebar layout for all project members.
 * @summary Get Reports Sidebar Layout
 */
export const getReportsSidebarLayout = async (
  projectId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetReportsSidebarLayoutResp> => {
  return customFetch<GetReportsSidebarLayoutResp>(getGetReportsSidebarLayoutUrl(projectId), {
    ...options,
    method: 'GET',
  });
};

export const getGetReportsSidebarLayoutQueryKey = (projectId: string) => {
  return [`/api/v1/projects/${projectId}/reports/sidebar-layout`] as const;
};

export const getGetReportsSidebarLayoutQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsSidebarLayout>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getReportsSidebarLayout>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsSidebarLayoutQueryKey(projectId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsSidebarLayout>>> = ({ signal }) =>
    getReportsSidebarLayout(projectId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getReportsSidebarLayout>>, TError, TData> & { queryKey: QueryKey };
};

export type GetReportsSidebarLayoutQueryResult = NonNullable<Awaited<ReturnType<typeof getReportsSidebarLayout>>>;
export type GetReportsSidebarLayoutQueryError = HTTPValidationError;

/**
 * @summary Get Reports Sidebar Layout
 */

export function useGetReportsSidebarLayout<
  TData = Awaited<ReturnType<typeof getReportsSidebarLayout>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getReportsSidebarLayout>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReportsSidebarLayoutQueryOptions(projectId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSetReportsSidebarLayoutUrl = (projectId: string) => {
  return `/api/v1/projects/${projectId}/reports/sidebar-layout`;
};

/**
 * Set the workspace sidebar order and visibility for every user of the project.
 *
 * Admin-only: the arrangement is shared, so members and viewers may only read it.
 * @summary Set Reports Sidebar Layout
 */
export const setReportsSidebarLayout = async (
  projectId: string,
  setReportsSidebarLayoutReq: SetReportsSidebarLayoutReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<SetReportsSidebarLayoutResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<SetReportsSidebarLayoutResp>(getSetReportsSidebarLayoutUrl(projectId), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setReportsSidebarLayoutReq),
  });
};

export const getSetReportsSidebarLayoutMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setReportsSidebarLayout>>,
    TError,
    SetReportsSidebarLayoutMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setReportsSidebarLayout>>,
  TError,
  SetReportsSidebarLayoutMutationVariables,
  TContext
> => {
  const mutationKey = ['setReportsSidebarLayout'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setReportsSidebarLayout>>,
    SetReportsSidebarLayoutMutationVariables
  > = (props) => {
    const { projectId, data } = props ?? {};

    return setReportsSidebarLayout(projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetReportsSidebarLayoutMutationResult = NonNullable<Awaited<ReturnType<typeof setReportsSidebarLayout>>>;
export type SetReportsSidebarLayoutMutationBody = SetReportsSidebarLayoutReq;
export type SetReportsSidebarLayoutMutationError = HTTPValidationError;
export type SetReportsSidebarLayoutMutationVariables = { projectId: string; data: SetReportsSidebarLayoutReq };

/**
 * @summary Set Reports Sidebar Layout
 */
export const useSetReportsSidebarLayout = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setReportsSidebarLayout>>,
    TError,
    SetReportsSidebarLayoutMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setReportsSidebarLayout>>,
  TError,
  SetReportsSidebarLayoutMutationVariables,
  TContext
> => {
  return useMutation(getSetReportsSidebarLayoutMutationOptions(options));
};
export const getUpdateReportUrl = (reportId: string) => {
  return `/api/v1/projects/reports/${reportId}`;
};

/**
 * Error if the report name already exists
 * @summary Update Report
 */
export const updateReport = async (
  reportId: string,
  updateReportReq: UpdateReportReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<UpdateReportResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<UpdateReportResp>(getUpdateReportUrl(reportId), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateReportReq),
  });
};

export const getUpdateReportMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReport>>,
    TError,
    UpdateReportMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof updateReport>>, TError, UpdateReportMutationVariables, TContext> => {
  const mutationKey = ['updateReport'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateReport>>, UpdateReportMutationVariables> = (
    props,
  ) => {
    const { reportId, data } = props ?? {};

    return updateReport(reportId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateReportMutationResult = NonNullable<Awaited<ReturnType<typeof updateReport>>>;
export type UpdateReportMutationBody = UpdateReportReq;
export type UpdateReportMutationError = HTTPValidationError;
export type UpdateReportMutationVariables = { reportId: string; data: UpdateReportReq };

/**
 * @summary Update Report
 */
export const useUpdateReport = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReport>>,
    TError,
    UpdateReportMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof updateReport>>, TError, UpdateReportMutationVariables, TContext> => {
  return useMutation(getUpdateReportMutationOptions(options));
};
export const getDeleteReportUrl = (reportId: string) => {
  return `/api/v1/projects/reports/${reportId}`;
};

/**
 * @summary Delete Report
 */
export const deleteReport = async (reportId: string, options?: Parameters<typeof customFetch>[1]): Promise<unknown> => {
  return customFetch<unknown>(getDeleteReportUrl(reportId), {
    ...options,
    method: 'DELETE',
  });
};

export const getDeleteReportMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReport>>,
    TError,
    DeleteReportMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteReport>>, TError, DeleteReportMutationVariables, TContext> => {
  const mutationKey = ['deleteReport'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteReport>>, DeleteReportMutationVariables> = (
    props,
  ) => {
    const { reportId } = props ?? {};

    return deleteReport(reportId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteReportMutationResult = NonNullable<Awaited<ReturnType<typeof deleteReport>>>;

export type DeleteReportMutationError = HTTPValidationError;
export type DeleteReportMutationVariables = { reportId: string };

/**
 * @summary Delete Report
 */
export const useDeleteReport = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReport>>,
    TError,
    DeleteReportMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof deleteReport>>, TError, DeleteReportMutationVariables, TContext> => {
  return useMutation(getDeleteReportMutationOptions(options));
};
export const getGetReportUrl = (reportId: string, params?: GetReportParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/projects/reports/${reportId}?${stringifiedParams}`
    : `/api/v1/projects/reports/${reportId}`;
};

/**
 * @summary Get Report
 */
export const getReport = async (
  reportId: string,
  params?: GetReportParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetReportResp> => {
  return customFetch<GetReportResp>(getGetReportUrl(reportId, params), {
    ...options,
    method: 'GET',
  });
};

export const getGetReportQueryKey = (reportId: string, params?: GetReportParams) => {
  return [`/api/v1/projects/reports/${reportId}`, ...(params ? [params] : [])] as const;
};

export const getGetReportQueryOptions = <TData = Awaited<ReturnType<typeof getReport>>, TError = HTTPValidationError>(
  reportId: string,
  params?: GetReportParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportQueryKey(reportId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReport>>> = ({ signal }) =>
    getReport(reportId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: reportId !== null && reportId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData> & { queryKey: QueryKey };
};

export type GetReportQueryResult = NonNullable<Awaited<ReturnType<typeof getReport>>>;
export type GetReportQueryError = HTTPValidationError;

/**
 * @summary Get Report
 */

export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = HTTPValidationError>(
  reportId: string,
  params?: GetReportParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReportQueryOptions(reportId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getFavoriteReportUrl = (projectId: string, reportId: string) => {
  return `/api/v1/projects/${projectId}/reports/${reportId}/favorite`;
};

/**
 * @summary Favorite Report
 */
export const favoriteReport = async (
  projectId: string,
  reportId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<FavoriteReportResp> => {
  return customFetch<FavoriteReportResp>(getFavoriteReportUrl(projectId, reportId), {
    ...options,
    method: 'PUT',
  });
};

export const getFavoriteReportMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof favoriteReport>>,
    TError,
    FavoriteReportMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof favoriteReport>>,
  TError,
  FavoriteReportMutationVariables,
  TContext
> => {
  const mutationKey = ['favoriteReport'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof favoriteReport>>, FavoriteReportMutationVariables> = (
    props,
  ) => {
    const { projectId, reportId } = props ?? {};

    return favoriteReport(projectId, reportId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type FavoriteReportMutationResult = NonNullable<Awaited<ReturnType<typeof favoriteReport>>>;

export type FavoriteReportMutationError = HTTPValidationError;
export type FavoriteReportMutationVariables = { projectId: string; reportId: string };

/**
 * @summary Favorite Report
 */
export const useFavoriteReport = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof favoriteReport>>,
    TError,
    FavoriteReportMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof favoriteReport>>,
  TError,
  FavoriteReportMutationVariables,
  TContext
> => {
  return useMutation(getFavoriteReportMutationOptions(options));
};
export const getRemoveFavoriteReportUrl = (projectId: string, reportId: string) => {
  return `/api/v1/projects/${projectId}/reports/${reportId}/favorite`;
};

/**
 * @summary Remove Favorite Report
 */
export const removeFavoriteReport = async (
  projectId: string,
  reportId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<UpdateReportResp> => {
  return customFetch<UpdateReportResp>(getRemoveFavoriteReportUrl(projectId, reportId), {
    ...options,
    method: 'DELETE',
  });
};

export const getRemoveFavoriteReportMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeFavoriteReport>>,
    TError,
    RemoveFavoriteReportMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeFavoriteReport>>,
  TError,
  RemoveFavoriteReportMutationVariables,
  TContext
> => {
  const mutationKey = ['removeFavoriteReport'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeFavoriteReport>>,
    RemoveFavoriteReportMutationVariables
  > = (props) => {
    const { projectId, reportId } = props ?? {};

    return removeFavoriteReport(projectId, reportId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveFavoriteReportMutationResult = NonNullable<Awaited<ReturnType<typeof removeFavoriteReport>>>;

export type RemoveFavoriteReportMutationError = HTTPValidationError;
export type RemoveFavoriteReportMutationVariables = { projectId: string; reportId: string };

/**
 * @summary Remove Favorite Report
 */
export const useRemoveFavoriteReport = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeFavoriteReport>>,
    TError,
    RemoveFavoriteReportMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeFavoriteReport>>,
  TError,
  RemoveFavoriteReportMutationVariables,
  TContext
> => {
  return useMutation(getRemoveFavoriteReportMutationOptions(options));
};
export const getSwitchDefaultReportUrl = (projectId: string, reportId: string) => {
  return `/api/v1/projects/${projectId}/reports/${reportId}/switch-default`;
};

/**
 * @summary Switch Default Report
 */
export const switchDefaultReport = async (
  projectId: string,
  reportId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<ConvertToDefaultReportResp> => {
  return customFetch<ConvertToDefaultReportResp>(getSwitchDefaultReportUrl(projectId, reportId), {
    ...options,
    method: 'POST',
  });
};

export const getSwitchDefaultReportMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof switchDefaultReport>>,
    TError,
    SwitchDefaultReportMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof switchDefaultReport>>,
  TError,
  SwitchDefaultReportMutationVariables,
  TContext
> => {
  const mutationKey = ['switchDefaultReport'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof switchDefaultReport>>,
    SwitchDefaultReportMutationVariables
  > = (props) => {
    const { projectId, reportId } = props ?? {};

    return switchDefaultReport(projectId, reportId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SwitchDefaultReportMutationResult = NonNullable<Awaited<ReturnType<typeof switchDefaultReport>>>;

export type SwitchDefaultReportMutationError = HTTPValidationError;
export type SwitchDefaultReportMutationVariables = { projectId: string; reportId: string };

/**
 * @summary Switch Default Report
 */
export const useSwitchDefaultReport = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof switchDefaultReport>>,
    TError,
    SwitchDefaultReportMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof switchDefaultReport>>,
  TError,
  SwitchDefaultReportMutationVariables,
  TContext
> => {
  return useMutation(getSwitchDefaultReportMutationOptions(options));
};
export const getCreateTemplateUrl = (projectId: string, reportId: string) => {
  return `/api/v1/projects/${projectId}/reports/${reportId}/create-template`;
};

/**
 * @summary Create Template
 */
export const createTemplate = async (
  projectId: string,
  reportId: string,
  createTemplateReq: CreateTemplateReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<ReportTemplate> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ReportTemplate>(getCreateTemplateUrl(projectId, reportId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createTemplateReq),
  });
};

export const getCreateTemplateMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTemplate>>,
    TError,
    CreateTemplateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTemplate>>,
  TError,
  CreateTemplateMutationVariables,
  TContext
> => {
  const mutationKey = ['createTemplate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTemplate>>, CreateTemplateMutationVariables> = (
    props,
  ) => {
    const { projectId, reportId, data } = props ?? {};

    return createTemplate(projectId, reportId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof createTemplate>>>;
export type CreateTemplateMutationBody = CreateTemplateReq;
export type CreateTemplateMutationError = HTTPValidationError;
export type CreateTemplateMutationVariables = { projectId: string; reportId: string; data: CreateTemplateReq };

/**
 * @summary Create Template
 */
export const useCreateTemplate = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTemplate>>,
    TError,
    CreateTemplateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTemplate>>,
  TError,
  CreateTemplateMutationVariables,
  TContext
> => {
  return useMutation(getCreateTemplateMutationOptions(options));
};
export const getGetCustomTemplatesUrl = (projectId: string, params?: GetCustomTemplatesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/projects/${projectId}/reports/custom-templates?${stringifiedParams}`
    : `/api/v1/projects/${projectId}/reports/custom-templates`;
};

/**
 * @summary Get Custom Templates
 */
export const getCustomTemplates = async (
  projectId: string,
  params?: GetCustomTemplatesParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedReportTemplate> => {
  return customFetch<PaginatedReportTemplate>(getGetCustomTemplatesUrl(projectId, params), {
    ...options,
    method: 'GET',
  });
};

export const getGetCustomTemplatesQueryKey = (projectId: string, params?: GetCustomTemplatesParams) => {
  return [`/api/v1/projects/${projectId}/reports/custom-templates`, ...(params ? [params] : [])] as const;
};

export const getGetCustomTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomTemplates>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  params?: GetCustomTemplatesParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCustomTemplates>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCustomTemplatesQueryKey(projectId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomTemplates>>> = ({ signal }) =>
    getCustomTemplates(projectId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getCustomTemplates>>, TError, TData> & { queryKey: QueryKey };
};

export type GetCustomTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomTemplates>>>;
export type GetCustomTemplatesQueryError = HTTPValidationError;

/**
 * @summary Get Custom Templates
 */

export function useGetCustomTemplates<
  TData = Awaited<ReturnType<typeof getCustomTemplates>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  params?: GetCustomTemplatesParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCustomTemplates>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCustomTemplatesQueryOptions(projectId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetDefaultTemplatesUrl = (projectId: string, params?: GetDefaultTemplatesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/projects/${projectId}/reports/default-templates?${stringifiedParams}`
    : `/api/v1/projects/${projectId}/reports/default-templates`;
};

/**
 * @summary Get Default Templates
 */
export const getDefaultTemplates = async (
  projectId: string,
  params?: GetDefaultTemplatesParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedReportTemplate> => {
  return customFetch<PaginatedReportTemplate>(getGetDefaultTemplatesUrl(projectId, params), {
    ...options,
    method: 'GET',
  });
};

export const getGetDefaultTemplatesQueryKey = (projectId: string, params?: GetDefaultTemplatesParams) => {
  return [`/api/v1/projects/${projectId}/reports/default-templates`, ...(params ? [params] : [])] as const;
};

export const getGetDefaultTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getDefaultTemplates>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  params?: GetDefaultTemplatesParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getDefaultTemplates>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDefaultTemplatesQueryKey(projectId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDefaultTemplates>>> = ({ signal }) =>
    getDefaultTemplates(projectId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getDefaultTemplates>>, TError, TData> & { queryKey: QueryKey };
};

export type GetDefaultTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof getDefaultTemplates>>>;
export type GetDefaultTemplatesQueryError = HTTPValidationError;

/**
 * @summary Get Default Templates
 */

export function useGetDefaultTemplates<
  TData = Awaited<ReturnType<typeof getDefaultTemplates>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  params?: GetDefaultTemplatesParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getDefaultTemplates>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDefaultTemplatesQueryOptions(projectId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetTagTemplatesUrl = (projectId: string, params: GetTagTemplatesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/projects/${projectId}/reports/tag-templates?${stringifiedParams}`
    : `/api/v1/projects/${projectId}/reports/tag-templates`;
};

/**
 * @summary Get Tag Templates
 */
export const getTagTemplates = async (
  projectId: string,
  params: GetTagTemplatesParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedReportTemplate> => {
  return customFetch<PaginatedReportTemplate>(getGetTagTemplatesUrl(projectId, params), {
    ...options,
    method: 'GET',
  });
};

export const getGetTagTemplatesQueryKey = (projectId: string, params?: GetTagTemplatesParams) => {
  return [`/api/v1/projects/${projectId}/reports/tag-templates`, ...(params ? [params] : [])] as const;
};

export const getGetTagTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getTagTemplates>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  params: GetTagTemplatesParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getTagTemplates>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTagTemplatesQueryKey(projectId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTagTemplates>>> = ({ signal }) =>
    getTagTemplates(projectId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getTagTemplates>>, TError, TData> & { queryKey: QueryKey };
};

export type GetTagTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof getTagTemplates>>>;
export type GetTagTemplatesQueryError = HTTPValidationError;

/**
 * @summary Get Tag Templates
 */

export function useGetTagTemplates<TData = Awaited<ReturnType<typeof getTagTemplates>>, TError = HTTPValidationError>(
  projectId: string,
  params: GetTagTemplatesParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getTagTemplates>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTagTemplatesQueryOptions(projectId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getReorderChartsUrl = (reportId: string) => {
  return `/api/v1/projects/reports/${reportId}/reorder-charts`;
};

/**
 * @summary Reorder Charts
 */
export const reorderCharts = async (
  reportId: string,
  reorderChartsReq: ReorderChartsReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetReportResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GetReportResp>(getReorderChartsUrl(reportId), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reorderChartsReq),
  });
};

export const getReorderChartsMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderCharts>>,
    TError,
    ReorderChartsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof reorderCharts>>, TError, ReorderChartsMutationVariables, TContext> => {
  const mutationKey = ['reorderCharts'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderCharts>>, ReorderChartsMutationVariables> = (
    props,
  ) => {
    const { reportId, data } = props ?? {};

    return reorderCharts(reportId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderChartsMutationResult = NonNullable<Awaited<ReturnType<typeof reorderCharts>>>;
export type ReorderChartsMutationBody = ReorderChartsReq;
export type ReorderChartsMutationError = HTTPValidationError;
export type ReorderChartsMutationVariables = { reportId: string; data: ReorderChartsReq };

/**
 * @summary Reorder Charts
 */
export const useReorderCharts = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderCharts>>,
    TError,
    ReorderChartsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof reorderCharts>>, TError, ReorderChartsMutationVariables, TContext> => {
  return useMutation(getReorderChartsMutationOptions(options));
};
export const getGetUsersPaginatedUrl = (projectId: string, params?: GetUsersPaginatedParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/projects/${projectId}/get-users?${stringifiedParams}`
    : `/api/v1/projects/${projectId}/get-users`;
};

/**
 * @summary Get Project Users Page
 */
export const getUsersPaginated = async (
  projectId: string,
  getUsersPayload: GetUsersPayload,
  params?: GetUsersPaginatedParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetUsersPageResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GetUsersPageResp>(getGetUsersPaginatedUrl(projectId, params), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getUsersPayload),
  });
};

export const getGetUsersPaginatedMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getUsersPaginated>>,
    TError,
    GetUsersPaginatedMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getUsersPaginated>>,
  TError,
  GetUsersPaginatedMutationVariables,
  TContext
> => {
  const mutationKey = ['getUsersPaginated'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getUsersPaginated>>,
    GetUsersPaginatedMutationVariables
  > = (props) => {
    const { projectId, data, params } = props ?? {};

    return getUsersPaginated(projectId, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetUsersPaginatedMutationResult = NonNullable<Awaited<ReturnType<typeof getUsersPaginated>>>;
export type GetUsersPaginatedMutationBody = GetUsersPayload;
export type GetUsersPaginatedMutationError = HTTPValidationError;
export type GetUsersPaginatedMutationVariables = {
  projectId: string;
  data: GetUsersPayload;
  params?: GetUsersPaginatedParams;
};

/**
 * @summary Get Project Users Page
 */
export const useGetUsersPaginated = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getUsersPaginated>>,
    TError,
    GetUsersPaginatedMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getUsersPaginated>>,
  TError,
  GetUsersPaginatedMutationVariables,
  TContext
> => {
  return useMutation(getGetUsersPaginatedMutationOptions(options));
};
export const getGetApiKeysUrl = (projectId: string) => {
  return `/api/v1/projects/${projectId}/api-keys`;
};

/**
 * @summary Get Project Api Keys
 */
export const getApiKeys = async (
  projectId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<ListAPIKeysResp> => {
  return customFetch<ListAPIKeysResp>(getGetApiKeysUrl(projectId), {
    ...options,
    method: 'GET',
  });
};

export const getGetApiKeysQueryKey = (projectId: string) => {
  return [`/api/v1/projects/${projectId}/api-keys`] as const;
};

export const getGetApiKeysQueryOptions = <TData = Awaited<ReturnType<typeof getApiKeys>>, TError = HTTPValidationError>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getApiKeys>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiKeysQueryKey(projectId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiKeys>>> = ({ signal }) =>
    getApiKeys(projectId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getApiKeys>>, TError, TData> & { queryKey: QueryKey };
};

export type GetApiKeysQueryResult = NonNullable<Awaited<ReturnType<typeof getApiKeys>>>;
export type GetApiKeysQueryError = HTTPValidationError;

/**
 * @summary Get Project Api Keys
 */

export function useGetApiKeys<TData = Awaited<ReturnType<typeof getApiKeys>>, TError = HTTPValidationError>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getApiKeys>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiKeysQueryOptions(projectId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateApiKeyUrl = (projectId: string) => {
  return `/api/v1/projects/${projectId}/api-keys`;
};

/**
 * @summary Create Api Key
 */
export const createApiKey = async (
  projectId: string,
  createAPIKeyReq: CreateAPIKeyReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<CreateAPIKeyResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CreateAPIKeyResp>(getCreateApiKeyUrl(projectId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createAPIKeyReq),
  });
};

export const getCreateApiKeyMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createApiKey>>,
    TError,
    CreateApiKeyMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof createApiKey>>, TError, CreateApiKeyMutationVariables, TContext> => {
  const mutationKey = ['createApiKey'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof createApiKey>>, CreateApiKeyMutationVariables> = (
    props,
  ) => {
    const { projectId, data } = props ?? {};

    return createApiKey(projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof createApiKey>>>;
export type CreateApiKeyMutationBody = CreateAPIKeyReq;
export type CreateApiKeyMutationError = HTTPValidationError;
export type CreateApiKeyMutationVariables = { projectId: string; data: CreateAPIKeyReq };

/**
 * @summary Create Api Key
 */
export const useCreateApiKey = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createApiKey>>,
    TError,
    CreateApiKeyMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof createApiKey>>, TError, CreateApiKeyMutationVariables, TContext> => {
  return useMutation(getCreateApiKeyMutationOptions(options));
};
export const getDeleteApiKeyUrl = (apiKeyId: string) => {
  return `/api/v1/projects/api-keys/${apiKeyId}`;
};

/**
 * @summary Delete Api Key
 */
export const deleteApiKey = async (
  apiKeyId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<ResponseMessage> => {
  return customFetch<ResponseMessage>(getDeleteApiKeyUrl(apiKeyId), {
    ...options,
    method: 'DELETE',
  });
};

export const getDeleteApiKeyMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiKey>>,
    TError,
    DeleteApiKeyMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteApiKey>>, TError, DeleteApiKeyMutationVariables, TContext> => {
  const mutationKey = ['deleteApiKey'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiKey>>, DeleteApiKeyMutationVariables> = (
    props,
  ) => {
    const { apiKeyId } = props ?? {};

    return deleteApiKey(apiKeyId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiKey>>>;

export type DeleteApiKeyMutationError = HTTPValidationError;
export type DeleteApiKeyMutationVariables = { apiKeyId: string };

/**
 * @summary Delete Api Key
 */
export const useDeleteApiKey = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiKey>>,
    TError,
    DeleteApiKeyMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof deleteApiKey>>, TError, DeleteApiKeyMutationVariables, TContext> => {
  return useMutation(getDeleteApiKeyMutationOptions(options));
};
export const getGetConfigurationUrl = () => {
  return `/api/v1/projects/get-project-configuration`;
};

/**
 * @summary Get Project Configuration
 */
export const getConfiguration = async (
  getProjectConfigurationReq: GetProjectConfigurationReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetProjectConfigurationResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GetProjectConfigurationResp>(getGetConfigurationUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getProjectConfigurationReq),
  });
};

export const getGetConfigurationMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getConfiguration>>,
    TError,
    GetConfigurationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getConfiguration>>,
  TError,
  GetConfigurationMutationVariables,
  TContext
> => {
  const mutationKey = ['getConfiguration'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getConfiguration>>,
    GetConfigurationMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return getConfiguration(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof getConfiguration>>>;
export type GetConfigurationMutationBody = GetProjectConfigurationReq;
export type GetConfigurationMutationError = HTTPValidationError;
export type GetConfigurationMutationVariables = { data: GetProjectConfigurationReq };

/**
 * @summary Get Project Configuration
 */
export const useGetConfiguration = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getConfiguration>>,
    TError,
    GetConfigurationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getConfiguration>>,
  TError,
  GetConfigurationMutationVariables,
  TContext
> => {
  return useMutation(getGetConfigurationMutationOptions(options));
};
export const getGetAvailableAggregatesUrl = () => {
  return `/api/v1/projects/get-available-aggregates`;
};

/**
 * Returns the available custom aggregates for a project
 * from its configuration
 * @summary Get Available Aggregates
 */
export const getAvailableAggregates = async (
  getProjectConfigurationReq: GetProjectConfigurationReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetAvailableAggregatesResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GetAvailableAggregatesResp>(getGetAvailableAggregatesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getProjectConfigurationReq),
  });
};

export const getGetAvailableAggregatesMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAvailableAggregates>>,
    TError,
    GetAvailableAggregatesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAvailableAggregates>>,
  TError,
  GetAvailableAggregatesMutationVariables,
  TContext
> => {
  const mutationKey = ['getAvailableAggregates'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAvailableAggregates>>,
    GetAvailableAggregatesMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return getAvailableAggregates(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAvailableAggregatesMutationResult = NonNullable<Awaited<ReturnType<typeof getAvailableAggregates>>>;
export type GetAvailableAggregatesMutationBody = GetProjectConfigurationReq;
export type GetAvailableAggregatesMutationError = HTTPValidationError;
export type GetAvailableAggregatesMutationVariables = { data: GetProjectConfigurationReq };

/**
 * @summary Get Available Aggregates
 */
export const useGetAvailableAggregates = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAvailableAggregates>>,
    TError,
    GetAvailableAggregatesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getAvailableAggregates>>,
  TError,
  GetAvailableAggregatesMutationVariables,
  TContext
> => {
  return useMutation(getGetAvailableAggregatesMutationOptions(options));
};
export const getUpdateConfigurationUrl = (params: UpdateConfigurationParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/projects/update-project-configuration?${stringifiedParams}`
    : `/api/v1/projects/update-project-configuration`;
};

/**
 * @summary Update Project Configuration
 */
export const updateConfiguration = async (
  projectConfiguration: ProjectConfiguration,
  params: UpdateConfigurationParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetProjectConfigurationResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GetProjectConfigurationResp>(getUpdateConfigurationUrl(params), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(projectConfiguration),
  });
};

export const getUpdateConfigurationMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateConfiguration>>,
    TError,
    UpdateConfigurationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateConfiguration>>,
  TError,
  UpdateConfigurationMutationVariables,
  TContext
> => {
  const mutationKey = ['updateConfiguration'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateConfiguration>>,
    UpdateConfigurationMutationVariables
  > = (props) => {
    const { data, params } = props ?? {};

    return updateConfiguration(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof updateConfiguration>>>;
export type UpdateConfigurationMutationBody = ProjectConfiguration;
export type UpdateConfigurationMutationError = HTTPValidationError;
export type UpdateConfigurationMutationVariables = { data: ProjectConfiguration; params: UpdateConfigurationParams };

/**
 * @summary Update Project Configuration
 */
export const useUpdateConfiguration = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateConfiguration>>,
    TError,
    UpdateConfigurationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateConfiguration>>,
  TError,
  UpdateConfigurationMutationVariables,
  TContext
> => {
  return useMutation(getUpdateConfigurationMutationOptions(options));
};
export const getUpsertProjectAggregateUrl = (params: UpsertProjectAggregateParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/projects/upsert-project-aggregate?${stringifiedParams}`
    : `/api/v1/projects/upsert-project-aggregate`;
};

/**
 * @summary Upsert Project Aggregate
 */
export const upsertProjectAggregate = async (
  projectAggregate: ProjectAggregate,
  params: UpsertProjectAggregateParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetProjectConfigurationResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GetProjectConfigurationResp>(getUpsertProjectAggregateUrl(params), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(projectAggregate),
  });
};

export const getUpsertProjectAggregateMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertProjectAggregate>>,
    TError,
    UpsertProjectAggregateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertProjectAggregate>>,
  TError,
  UpsertProjectAggregateMutationVariables,
  TContext
> => {
  const mutationKey = ['upsertProjectAggregate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertProjectAggregate>>,
    UpsertProjectAggregateMutationVariables
  > = (props) => {
    const { data, params } = props ?? {};

    return upsertProjectAggregate(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertProjectAggregateMutationResult = NonNullable<Awaited<ReturnType<typeof upsertProjectAggregate>>>;
export type UpsertProjectAggregateMutationBody = ProjectAggregate;
export type UpsertProjectAggregateMutationError = HTTPValidationError;
export type UpsertProjectAggregateMutationVariables = { data: ProjectAggregate; params: UpsertProjectAggregateParams };

/**
 * @summary Upsert Project Aggregate
 */
export const useUpsertProjectAggregate = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertProjectAggregate>>,
    TError,
    UpsertProjectAggregateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upsertProjectAggregate>>,
  TError,
  UpsertProjectAggregateMutationVariables,
  TContext
> => {
  return useMutation(getUpsertProjectAggregateMutationOptions(options));
};
export const getDeleteProjectAggregateUrl = (params: DeleteProjectAggregateParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/projects/delete-project-aggregate?${stringifiedParams}`
    : `/api/v1/projects/delete-project-aggregate`;
};

/**
 * @summary Delete Project Aggregate
 */
export const deleteProjectAggregate = async (
  params: DeleteProjectAggregateParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetProjectConfigurationResp> => {
  return customFetch<GetProjectConfigurationResp>(getDeleteProjectAggregateUrl(params), {
    ...options,
    method: 'DELETE',
  });
};

export const getDeleteProjectAggregateMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProjectAggregate>>,
    TError,
    DeleteProjectAggregateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProjectAggregate>>,
  TError,
  DeleteProjectAggregateMutationVariables,
  TContext
> => {
  const mutationKey = ['deleteProjectAggregate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProjectAggregate>>,
    DeleteProjectAggregateMutationVariables
  > = (props) => {
    const { params } = props ?? {};

    return deleteProjectAggregate(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProjectAggregateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProjectAggregate>>>;

export type DeleteProjectAggregateMutationError = HTTPValidationError;
export type DeleteProjectAggregateMutationVariables = { params: DeleteProjectAggregateParams };

/**
 * @summary Delete Project Aggregate
 */
export const useDeleteProjectAggregate = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProjectAggregate>>,
    TError,
    DeleteProjectAggregateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteProjectAggregate>>,
  TError,
  DeleteProjectAggregateMutationVariables,
  TContext
> => {
  return useMutation(getDeleteProjectAggregateMutationOptions(options));
};
export const getGetAvailableFiltersUrl = (params: GetAvailableFiltersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/projects/filters?${stringifiedParams}` : `/api/v1/projects/filters`;
};

/**
 * @summary Available Filters
 */
export const getAvailableFilters = async (
  params: GetAvailableFiltersParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<AvailableFiltersResp> => {
  return customFetch<AvailableFiltersResp>(getGetAvailableFiltersUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getGetAvailableFiltersQueryKey = (params?: GetAvailableFiltersParams) => {
  return [`/api/v1/projects/filters`, ...(params ? [params] : [])] as const;
};

export const getGetAvailableFiltersQueryOptions = <
  TData = Awaited<ReturnType<typeof getAvailableFilters>>,
  TError = HTTPValidationError,
>(
  params: GetAvailableFiltersParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getAvailableFilters>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAvailableFiltersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailableFilters>>> = ({ signal }) =>
    getAvailableFilters(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAvailableFilters>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAvailableFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof getAvailableFilters>>>;
export type GetAvailableFiltersQueryError = HTTPValidationError;

/**
 * @summary Available Filters
 */

export function useGetAvailableFilters<
  TData = Awaited<ReturnType<typeof getAvailableFilters>>,
  TError = HTTPValidationError,
>(
  params: GetAvailableFiltersParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getAvailableFilters>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAvailableFiltersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPenetrationTagsUrl = (projectId: string) => {
  return `/api/v1/projects/${projectId}/penetration-tags`;
};

/**
 * @summary Available Penetration Tags
 */
export const getPenetrationTags = async (
  projectId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<AvailableTagsResp> => {
  return customFetch<AvailableTagsResp>(getGetPenetrationTagsUrl(projectId), {
    ...options,
    method: 'GET',
  });
};

export const getGetPenetrationTagsQueryKey = (projectId: string) => {
  return [`/api/v1/projects/${projectId}/penetration-tags`] as const;
};

export const getGetPenetrationTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPenetrationTags>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getPenetrationTags>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPenetrationTagsQueryKey(projectId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPenetrationTags>>> = ({ signal }) =>
    getPenetrationTags(projectId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getPenetrationTags>>, TError, TData> & { queryKey: QueryKey };
};

export type GetPenetrationTagsQueryResult = NonNullable<Awaited<ReturnType<typeof getPenetrationTags>>>;
export type GetPenetrationTagsQueryError = HTTPValidationError;

/**
 * @summary Available Penetration Tags
 */

export function useGetPenetrationTags<
  TData = Awaited<ReturnType<typeof getPenetrationTags>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getPenetrationTags>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPenetrationTagsQueryOptions(projectId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetFilterGroupsUrl = (projectId: string) => {
  return `/api/v1/projects${projectId}/filter-groups`;
};

/**
 * @summary Get Filter Groups
 */
export const getFilterGroups = async (
  projectId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<FilterGroup[]> => {
  return customFetch<FilterGroup[]>(getGetFilterGroupsUrl(projectId), {
    ...options,
    method: 'GET',
  });
};

export const getGetFilterGroupsQueryKey = (projectId: string) => {
  return [`/api/v1/projects${projectId}/filter-groups`] as const;
};

export const getGetFilterGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof getFilterGroups>>,
  TError = HTTPValidationError,
>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getFilterGroups>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFilterGroupsQueryKey(projectId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFilterGroups>>> = ({ signal }) =>
    getFilterGroups(projectId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getFilterGroups>>, TError, TData> & { queryKey: QueryKey };
};

export type GetFilterGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getFilterGroups>>>;
export type GetFilterGroupsQueryError = HTTPValidationError;

/**
 * @summary Get Filter Groups
 */

export function useGetFilterGroups<TData = Awaited<ReturnType<typeof getFilterGroups>>, TError = HTTPValidationError>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getFilterGroups>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFilterGroupsQueryOptions(projectId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpsertFilterGroupUrl = (projectId: string) => {
  return `/api/v1/projects${projectId}/filter-group`;
};

/**
 * @summary Upsert Filter Group
 */
export const upsertFilterGroup = async (
  projectId: string,
  filterGroupUpsert: FilterGroupUpsert,
  options?: Parameters<typeof customFetch>[1],
): Promise<ResponseMessage> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ResponseMessage>(getUpsertFilterGroupUrl(projectId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(filterGroupUpsert),
  });
};

export const getUpsertFilterGroupMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertFilterGroup>>,
    TError,
    UpsertFilterGroupMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertFilterGroup>>,
  TError,
  UpsertFilterGroupMutationVariables,
  TContext
> => {
  const mutationKey = ['upsertFilterGroup'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertFilterGroup>>,
    UpsertFilterGroupMutationVariables
  > = (props) => {
    const { projectId, data } = props ?? {};

    return upsertFilterGroup(projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertFilterGroupMutationResult = NonNullable<Awaited<ReturnType<typeof upsertFilterGroup>>>;
export type UpsertFilterGroupMutationBody = FilterGroupUpsert;
export type UpsertFilterGroupMutationError = HTTPValidationError;
export type UpsertFilterGroupMutationVariables = { projectId: string; data: FilterGroupUpsert };

/**
 * @summary Upsert Filter Group
 */
export const useUpsertFilterGroup = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertFilterGroup>>,
    TError,
    UpsertFilterGroupMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upsertFilterGroup>>,
  TError,
  UpsertFilterGroupMutationVariables,
  TContext
> => {
  return useMutation(getUpsertFilterGroupMutationOptions(options));
};
export const getDeleteFilterGroupUrl = (projectId: string, params: DeleteFilterGroupParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/projects${projectId}/filter-group?${stringifiedParams}`
    : `/api/v1/projects${projectId}/filter-group`;
};

/**
 * @summary Delete Filter Group
 */
export const deleteFilterGroup = async (
  projectId: string,
  params: DeleteFilterGroupParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<ResponseMessage> => {
  return customFetch<ResponseMessage>(getDeleteFilterGroupUrl(projectId, params), {
    ...options,
    method: 'DELETE',
  });
};

export const getDeleteFilterGroupMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFilterGroup>>,
    TError,
    DeleteFilterGroupMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFilterGroup>>,
  TError,
  DeleteFilterGroupMutationVariables,
  TContext
> => {
  const mutationKey = ['deleteFilterGroup'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFilterGroup>>,
    DeleteFilterGroupMutationVariables
  > = (props) => {
    const { projectId, params } = props ?? {};

    return deleteFilterGroup(projectId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFilterGroupMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFilterGroup>>>;

export type DeleteFilterGroupMutationError = HTTPValidationError;
export type DeleteFilterGroupMutationVariables = { projectId: string; params: DeleteFilterGroupParams };

/**
 * @summary Delete Filter Group
 */
export const useDeleteFilterGroup = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFilterGroup>>,
    TError,
    DeleteFilterGroupMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteFilterGroup>>,
  TError,
  DeleteFilterGroupMutationVariables,
  TContext
> => {
  return useMutation(getDeleteFilterGroupMutationOptions(options));
};
export const getGetUsersUrl = (projectId: string) => {
  return `/api/v1/projects${projectId}/users`;
};

/**
 * @summary Get Project Users
 */
export const getUsers = async (
  projectId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<ProjectUsersResp> => {
  return customFetch<ProjectUsersResp>(getGetUsersUrl(projectId), {
    ...options,
    method: 'GET',
  });
};

export const getGetUsersQueryKey = (projectId: string) => {
  return [`/api/v1/projects${projectId}/users`] as const;
};

export const getGetUsersQueryOptions = <TData = Awaited<ReturnType<typeof getUsers>>, TError = HTTPValidationError>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUsersQueryKey(projectId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsers>>> = ({ signal }) =>
    getUsers(projectId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: projectId !== null && projectId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData> & { queryKey: QueryKey };
};

export type GetUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getUsers>>>;
export type GetUsersQueryError = HTTPValidationError;

/**
 * @summary Get Project Users
 */

export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = HTTPValidationError>(
  projectId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUsersQueryOptions(projectId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRevokeUsersUrl = (projectId: string) => {
  return `/api/v1/projects${projectId}/revoke-users`;
};

/**
 * @summary Revoke Project Users
 */
export const revokeUsers = async (
  projectId: string,
  editProjectUsersReq: EditProjectUsersReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<ResponseMessage> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ResponseMessage>(getRevokeUsersUrl(projectId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(editProjectUsersReq),
  });
};

export const getRevokeUsersMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeUsers>>,
    TError,
    RevokeUsersMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof revokeUsers>>, TError, RevokeUsersMutationVariables, TContext> => {
  const mutationKey = ['revokeUsers'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeUsers>>, RevokeUsersMutationVariables> = (
    props,
  ) => {
    const { projectId, data } = props ?? {};

    return revokeUsers(projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeUsersMutationResult = NonNullable<Awaited<ReturnType<typeof revokeUsers>>>;
export type RevokeUsersMutationBody = EditProjectUsersReq;
export type RevokeUsersMutationError = HTTPValidationError;
export type RevokeUsersMutationVariables = { projectId: string; data: EditProjectUsersReq };

/**
 * @summary Revoke Project Users
 */
export const useRevokeUsers = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeUsers>>,
    TError,
    RevokeUsersMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof revokeUsers>>, TError, RevokeUsersMutationVariables, TContext> => {
  return useMutation(getRevokeUsersMutationOptions(options));
};
export const getEnableProjectUsersUrl = (projectId: string) => {
  return `/api/v1/projects${projectId}/enable-users`;
};

/**
 * @summary Enable Project Users
 */
export const enableProjectUsers = async (
  projectId: string,
  editProjectUsersReq: EditProjectUsersReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<ResponseMessage> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ResponseMessage>(getEnableProjectUsersUrl(projectId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(editProjectUsersReq),
  });
};

export const getEnableProjectUsersMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enableProjectUsers>>,
    TError,
    EnableProjectUsersMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enableProjectUsers>>,
  TError,
  EnableProjectUsersMutationVariables,
  TContext
> => {
  const mutationKey = ['enableProjectUsers'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enableProjectUsers>>,
    EnableProjectUsersMutationVariables
  > = (props) => {
    const { projectId, data } = props ?? {};

    return enableProjectUsers(projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EnableProjectUsersMutationResult = NonNullable<Awaited<ReturnType<typeof enableProjectUsers>>>;
export type EnableProjectUsersMutationBody = EditProjectUsersReq;
export type EnableProjectUsersMutationError = HTTPValidationError;
export type EnableProjectUsersMutationVariables = { projectId: string; data: EditProjectUsersReq };

/**
 * @summary Enable Project Users
 */
export const useEnableProjectUsers = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enableProjectUsers>>,
    TError,
    EnableProjectUsersMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof enableProjectUsers>>,
  TError,
  EnableProjectUsersMutationVariables,
  TContext
> => {
  return useMutation(getEnableProjectUsersMutationOptions(options));
};
export const getSearchProjectUrl = (projectId: string) => {
  return `/api/v1/projects/${projectId}/search`;
};

/**
 * Search interactions within a single project (legacy API).
 * @summary Search Project
 */
export const searchProject = async (
  projectId: string,
  searchProjectsReq: SearchProjectsReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<LegacySearchResults> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<LegacySearchResults>(getSearchProjectUrl(projectId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(searchProjectsReq),
  });
};

export const getSearchProjectMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchProject>>,
    TError,
    SearchProjectMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof searchProject>>, TError, SearchProjectMutationVariables, TContext> => {
  const mutationKey = ['searchProject'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchProject>>, SearchProjectMutationVariables> = (
    props,
  ) => {
    const { projectId, data } = props ?? {};

    return searchProject(projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchProjectMutationResult = NonNullable<Awaited<ReturnType<typeof searchProject>>>;
export type SearchProjectMutationBody = SearchProjectsReq;
export type SearchProjectMutationError = HTTPValidationError;
export type SearchProjectMutationVariables = { projectId: string; data: SearchProjectsReq };

/**
 * @summary Search Project
 */
export const useSearchProject = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchProject>>,
    TError,
    SearchProjectMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof searchProject>>, TError, SearchProjectMutationVariables, TContext> => {
  return useMutation(getSearchProjectMutationOptions(options));
};
export const getGetProcessingStatusUrl = () => {
  return `/api/v1/projects/processing-status`;
};

/**
 * @summary Get Project Processing Status
 */
export const getProcessingStatus = async (
  getProjectConfigurationReq: GetProjectConfigurationReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<ProcessingStatusResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ProcessingStatusResp>(getGetProcessingStatusUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getProjectConfigurationReq),
  });
};

export const getGetProcessingStatusMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getProcessingStatus>>,
    TError,
    GetProcessingStatusMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getProcessingStatus>>,
  TError,
  GetProcessingStatusMutationVariables,
  TContext
> => {
  const mutationKey = ['getProcessingStatus'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getProcessingStatus>>,
    GetProcessingStatusMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return getProcessingStatus(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetProcessingStatusMutationResult = NonNullable<Awaited<ReturnType<typeof getProcessingStatus>>>;
export type GetProcessingStatusMutationBody = GetProjectConfigurationReq;
export type GetProcessingStatusMutationError = HTTPValidationError;
export type GetProcessingStatusMutationVariables = { data: GetProjectConfigurationReq };

/**
 * @summary Get Project Processing Status
 */
export const useGetProcessingStatus = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getProcessingStatus>>,
    TError,
    GetProcessingStatusMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getProcessingStatus>>,
  TError,
  GetProcessingStatusMutationVariables,
  TContext
> => {
  return useMutation(getGetProcessingStatusMutationOptions(options));
};
export const getCreateVariableUrl = (projectId: string) => {
  return `/api/v1/projects/${projectId}/create-variable`;
};

/**
 * @summary Create Variable
 */
export const createVariable = async (
  projectId: string,
  createVariableReq: CreateVariableReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<CreateVariableResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CreateVariableResp>(getCreateVariableUrl(projectId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createVariableReq),
  });
};

export const getCreateVariableMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVariable>>,
    TError,
    CreateVariableMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createVariable>>,
  TError,
  CreateVariableMutationVariables,
  TContext
> => {
  const mutationKey = ['createVariable'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVariable>>, CreateVariableMutationVariables> = (
    props,
  ) => {
    const { projectId, data } = props ?? {};

    return createVariable(projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateVariableMutationResult = NonNullable<Awaited<ReturnType<typeof createVariable>>>;
export type CreateVariableMutationBody = CreateVariableReq;
export type CreateVariableMutationError = HTTPValidationError;
export type CreateVariableMutationVariables = { projectId: string; data: CreateVariableReq };

/**
 * @summary Create Variable
 */
export const useCreateVariable = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVariable>>,
    TError,
    CreateVariableMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createVariable>>,
  TError,
  CreateVariableMutationVariables,
  TContext
> => {
  return useMutation(getCreateVariableMutationOptions(options));
};
export const getGetDeleteVariableImpactUrl = (projectId: string, variableSlug: string) => {
  return `/api/v1/projects/${projectId}/variables/${variableSlug}/delete-impact`;
};

/**
 * @summary Get Delete Variable Impact
 */
export const getDeleteVariableImpact = async (
  projectId: string,
  variableSlug: string,
  deleteVariableBody: DeleteVariableBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<DeleteVariableImpactResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<DeleteVariableImpactResp>(getGetDeleteVariableImpactUrl(projectId, variableSlug), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deleteVariableBody),
  });
};

export const getGetDeleteVariableImpactMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getDeleteVariableImpact>>,
    TError,
    GetDeleteVariableImpactMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getDeleteVariableImpact>>,
  TError,
  GetDeleteVariableImpactMutationVariables,
  TContext
> => {
  const mutationKey = ['getDeleteVariableImpact'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getDeleteVariableImpact>>,
    GetDeleteVariableImpactMutationVariables
  > = (props) => {
    const { projectId, variableSlug, data } = props ?? {};

    return getDeleteVariableImpact(projectId, variableSlug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetDeleteVariableImpactMutationResult = NonNullable<Awaited<ReturnType<typeof getDeleteVariableImpact>>>;
export type GetDeleteVariableImpactMutationBody = DeleteVariableBody;
export type GetDeleteVariableImpactMutationError = HTTPValidationError;
export type GetDeleteVariableImpactMutationVariables = {
  projectId: string;
  variableSlug: string;
  data: DeleteVariableBody;
};

/**
 * @summary Get Delete Variable Impact
 */
export const useGetDeleteVariableImpact = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getDeleteVariableImpact>>,
    TError,
    GetDeleteVariableImpactMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getDeleteVariableImpact>>,
  TError,
  GetDeleteVariableImpactMutationVariables,
  TContext
> => {
  return useMutation(getGetDeleteVariableImpactMutationOptions(options));
};
export const getDeleteVariableUrl = (projectId: string, variableSlug: string) => {
  return `/api/v1/projects/${projectId}/variables/${variableSlug}`;
};

/**
 * @summary Delete Variable
 */
export const deleteVariable = async (
  projectId: string,
  variableSlug: string,
  deleteVariableBody: DeleteVariableBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<DeleteVariableResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<DeleteVariableResp>(getDeleteVariableUrl(projectId, variableSlug), {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deleteVariableBody),
  });
};

export const getDeleteVariableMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVariable>>,
    TError,
    DeleteVariableMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteVariable>>,
  TError,
  DeleteVariableMutationVariables,
  TContext
> => {
  const mutationKey = ['deleteVariable'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVariable>>, DeleteVariableMutationVariables> = (
    props,
  ) => {
    const { projectId, variableSlug, data } = props ?? {};

    return deleteVariable(projectId, variableSlug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteVariableMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVariable>>>;
export type DeleteVariableMutationBody = DeleteVariableBody;
export type DeleteVariableMutationError = HTTPValidationError;
export type DeleteVariableMutationVariables = { projectId: string; variableSlug: string; data: DeleteVariableBody };

/**
 * @summary Delete Variable
 */
export const useDeleteVariable = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVariable>>,
    TError,
    DeleteVariableMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteVariable>>,
  TError,
  DeleteVariableMutationVariables,
  TContext
> => {
  return useMutation(getDeleteVariableMutationOptions(options));
};
export const getUpdateVariableUrl = (projectId: string, variableSlug: string) => {
  return `/api/v1/projects/${projectId}/variables/${variableSlug}`;
};

/**
 * @summary Update Variable
 */
export const updateVariable = async (
  projectId: string,
  variableSlug: string,
  createVariableReq: CreateVariableReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<UpdateVariableResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<UpdateVariableResp>(getUpdateVariableUrl(projectId, variableSlug), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createVariableReq),
  });
};

export const getUpdateVariableMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVariable>>,
    TError,
    UpdateVariableMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVariable>>,
  TError,
  UpdateVariableMutationVariables,
  TContext
> => {
  const mutationKey = ['updateVariable'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVariable>>, UpdateVariableMutationVariables> = (
    props,
  ) => {
    const { projectId, variableSlug, data } = props ?? {};

    return updateVariable(projectId, variableSlug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateVariableMutationResult = NonNullable<Awaited<ReturnType<typeof updateVariable>>>;
export type UpdateVariableMutationBody = CreateVariableReq;
export type UpdateVariableMutationError = HTTPValidationError;
export type UpdateVariableMutationVariables = { projectId: string; variableSlug: string; data: CreateVariableReq };

/**
 * @summary Update Variable
 */
export const useUpdateVariable = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVariable>>,
    TError,
    UpdateVariableMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateVariable>>,
  TError,
  UpdateVariableMutationVariables,
  TContext
> => {
  return useMutation(getUpdateVariableMutationOptions(options));
};
export const getInvalidateCacheUrl = (projectId: string) => {
  return `/api/v1/projects/${projectId}/invalidate-cache`;
};

/**
 * @summary Invalidate Cache
 */
export const invalidateCache = async (
  projectId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<ResponseMessage> => {
  return customFetch<ResponseMessage>(getInvalidateCacheUrl(projectId), {
    ...options,
    method: 'POST',
  });
};

export const getInvalidateCacheMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof invalidateCache>>,
    TError,
    InvalidateCacheMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof invalidateCache>>,
  TError,
  InvalidateCacheMutationVariables,
  TContext
> => {
  const mutationKey = ['invalidateCache'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof invalidateCache>>, InvalidateCacheMutationVariables> = (
    props,
  ) => {
    const { projectId } = props ?? {};

    return invalidateCache(projectId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InvalidateCacheMutationResult = NonNullable<Awaited<ReturnType<typeof invalidateCache>>>;

export type InvalidateCacheMutationError = HTTPValidationError;
export type InvalidateCacheMutationVariables = { projectId: string };

/**
 * @summary Invalidate Cache
 */
export const useInvalidateCache = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof invalidateCache>>,
    TError,
    InvalidateCacheMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof invalidateCache>>,
  TError,
  InvalidateCacheMutationVariables,
  TContext
> => {
  return useMutation(getInvalidateCacheMutationOptions(options));
};
